import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { FormError, FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface AgentRefNumberFormFieldProps {}

export const AgentRefNumberFormField: React.FC<AgentRefNumberFormFieldProps> = ({}) => {
  const { control, register, watch, setValue } = useFormContext<{ agent_ref_number: string }>()

  const agent_ref_number = watch('agent_ref_number')

  useEffect(() => {
    if (agent_ref_number === '') {
      setValue('agent_ref_number', null as unknown as string, { shouldValidate: true })
    }
  }, [agent_ref_number])

  return (
    <FormField
      name="agent_ref_number"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Agent / PB Ref</FormLabel>
              <FormError />
            </div>
            <Input placeholder="Agent / PB Ref" type="text" {...register('agent_ref_number')} />
          </FormItem>
        )
      }}
    />
  )
}
